import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/index/company-name.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "bannar" }
const _hoisted_3 = { class: "pic-list" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "business-list" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  key: 0,
  class: "char"
}
const _hoisted_9 = { class: "case" }
const _hoisted_10 = { class: "common-module" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "solution" }
const _hoisted_13 = { class: "common-module" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "solution-case" }
const _hoisted_16 = { class: "container" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "image" }
const _hoisted_19 = ["src"]
const _hoisted_20 = { class: "title" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  key: 2,
  class: "dot"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "about" }
const _hoisted_25 = { class: "about-list" }
const _hoisted_26 = { class: "circle" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = { class: "content" }
const _hoisted_29 = { class: "product" }
const _hoisted_30 = { class: "common-module" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "product-case" }
const _hoisted_33 = { class: "image" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "product-case-item" }
const _hoisted_36 = { class: "left" }
const _hoisted_37 = { class: "type" }
const _hoisted_38 = { class: "module" }
const _hoisted_39 = { class: "right" }
const _hoisted_40 = { class: "name" }
const _hoisted_41 = { class: "zh-name" }
const _hoisted_42 = { class: "en-name" }
const _hoisted_43 = { class: "intro" }
const _hoisted_44 = { class: "product-case-list" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onMouseover"]
const _hoisted_47 = { class: "left" }
const _hoisted_48 = { class: "type" }
const _hoisted_49 = { class: "module" }
const _hoisted_50 = { class: "right" }
const _hoisted_51 = { class: "name" }
const _hoisted_52 = { class: "zh-name" }
const _hoisted_53 = { class: "en-name" }
const _hoisted_54 = { class: "intro" }
const _hoisted_55 = { class: "certificate-full" }
const _hoisted_56 = { class: "certificate-container" }
const _hoisted_57 = { class: "certificate-list" }
const _hoisted_58 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MyHeader = _resolveComponent("MyHeader")!
  const _component_MyPage = _resolveComponent("MyPage")!
  const _component_MyFooter = _resolveComponent("MyFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MyHeader, { currentMenuIndex: 0 }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moduleList, (item, index) => {
          return (_openBlock(), _createBlock(_Transition, {
            name: "bannarImage",
            key: index
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("img", {
                src: item.img,
                alt: ""
              }, null, 8, _hoisted_4), [
                [_vShow, _ctx.currentBannerIndex === index]
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"logo\" data-v-7c56ede4><img src=\"" + _imports_0 + "\" alt=\"\" data-v-7c56ede4></div><div class=\"title\" data-v-7c56ede4>广州捍御者与时代同步</div><div class=\"text-list\" data-v-7c56ede4><div class=\"text-style1\" data-v-7c56ede4>研发·科技</div><div class=\"text-style2\" data-v-7c56ede4>RESEARCH</div><div class=\"text-style3\" data-v-7c56ede4>DEVELOP</div></div>", 3)),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "business-item",
              key: index
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(item), 1),
              (index !== _ctx.businessList.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "/"))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "common-title" }, [
        _createElementVNode("div", { class: "zh-title" }, "公司案例"),
        _createElementVNode("div", { class: "en-title" }, "CASE")
      ], -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseList, (it, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("img", {
                src: it.img,
                alt: ""
              }, null, 8, _hoisted_11),
              _createElementVNode("span", null, _toDisplayString(it.title), 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "common-title" }, [
        _createElementVNode("div", { class: "zh-title" }, "解决方案"),
        _createElementVNode("div", { class: "en-title" }, "SOLUTION")
      ], -1)),
      _createElementVNode("div", _hoisted_13, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionModule, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(_ctx.currnetSolutionModuleIndex === index ? 'active-item common-module-item' : 'common-module-item'),
            key: index,
            onClick: ($event: any) => (_ctx.currnetSolutionModuleIndex = index)
          }, _toDisplayString(item), 11, _hoisted_14))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "solution-case-list",
            style: _normalizeStyle(`width: ${378 * _ctx.solutionList.length}px; transform: translateX(${-376 * (_ctx.currentSolutionPage - 1)}px)`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutionList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "solution-case-item",
                key: index,
                onClick: ($event: any) => (_ctx.jumpSolutionDetail(item.key))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: ""
                  }, null, 8, _hoisted_19)
                ]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(item.content), 1),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "more" }, "更多", -1))
              ], 8, _hoisted_17))
            }), 128))
          ], 4)
        ]),
        (_ctx.solutionList.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentSolutionPage = _ctx.currentSolutionPage > 1 ? _ctx.currentSolutionPage - 1 : _ctx.currentSolutionPage))
            }, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("i", {
                class: "iconfont iconjiantou4",
                style: {"font-size":"16px"}
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.solutionList.length > 3)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "right",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentSolutionPage = _ctx.currentSolutionPage < _ctx.solutionList.length - 2 ? _ctx.currentSolutionPage + 1 : _ctx.currentSolutionPage))
            }, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("i", {
                class: "iconfont iconjiantou4",
                style: {"font-size":"16px"}
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (_ctx.solutionList.length > 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(_ctx.currentSolutionPage === index + 1 ? 'active-item dot-item' : 'dot-item'),
                  key: index,
                  onClick: ($event: any) => (_ctx.currentSolutionPage = index + 1)
                }, null, 10, _hoisted_23))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aboutList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "about-item",
            key: index
          }, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("i", {
                class: _normalizeClass('iconfont ' + item.icon),
                style: {"font-size":"48px"}
              }, null, 2)
            ]),
            _createElementVNode("div", _hoisted_27, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_28, _toDisplayString(item.content), 1)
          ]))
        }), 128))
      ]),
      _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"card\" data-v-7c56ede4><div class=\"common-title\" data-v-7c56ede4><div class=\"zh-title\" data-v-7c56ede4>关于我们</div><div class=\"en-title\" data-v-7c56ede4>ABOUT US</div></div><div class=\"content\" data-v-7c56ede4><div class=\"text\" data-v-7c56ede4>        广州市捍御者信息科技有限公司（简称捍御者）成立于2016 年，位于广州黄埔区，主要从事基础设施和公共建筑的智能化与信息化相关的软硬件开发、生产和交付。</div><div class=\"text\" data-v-7c56ede4>         捍御者专注于网络、通信、监控、安防、自动化、运维、运营的技术研究，提供相关系统性解决方案、产品开发设计和服务交付，主要提供针对基础设施、公共建筑等场景下的高性价比、高集成度、高健壮性的软硬件产品及解决方案。 </div><div class=\"text\" data-v-7c56ede4>         捍御者自主研发，针对基础设施和公共建筑的特点，创造性地将专用、融合、简约的思想倾注到智能化系统和智能化产品中，颠覆了传统的智能化产品和方案，整合智能建筑运行的各项关键信息，逐步孕育出建筑智能化的创新生态。 </div><div class=\"text\" data-v-7c56ede4>         捍御者在广州设有研发中心和生产基地，是广州市高新技术企业、创新性中小企业、专精特新中小企业，取得12项发明专利，是智慧建筑相关团体标准的主编单位和智慧管廊相关国家标准的参编单位。 </div></div></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_29, [
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "common-title" }, [
        _createElementVNode("div", { class: "zh-title" }, "产品设备"),
        _createElementVNode("div", { class: "en-title" }, "PRODUCT EQUIPMENT")
      ], -1)),
      _createElementVNode("div", _hoisted_30, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productModule, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(_ctx.currnetProductModuleIndex === index ? 'active-item common-module-item' : 'common-module-item'),
            key: index,
            onClick: ($event: any) => (_ctx.currnetProductModuleIndex = index)
          }, _toDisplayString(item), 11, _hoisted_31))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("div", {
          class: "product-case-preview",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.jumpProductDetail && _ctx.jumpProductDetail(...args))),
          onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currnetProductHover = 99)),
          onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currnetProductHover = -1))
        }, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("img", {
              src: _ctx.currentProduct.img,
              alt: ""
            }, null, 8, _hoisted_34)
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.currentProduct.type), 1),
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "char" }, null, -1)),
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.currentProduct.module), 1)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.currentProduct.zhName), 1),
                _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.currentProduct.enName), 1)
              ]),
              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.currentProduct.intro), 1)
            ])
          ]),
          _createElementVNode("div", {
            class: "bg",
            style: _normalizeStyle(`height: ${_ctx.currnetProductHover === 99 ? '100%' : '0px'}`)
          }, null, 4)
        ], 32),
        _createElementVNode("div", _hoisted_44, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (_ctx.currnetProductIndex = index)
            }, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(_ctx.currnetProductIndex === index ? 'product-case-item active-item' : 'product-case-item'),
                onMouseover: ($event: any) => (_ctx.currnetProductHover = index),
                onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.currnetProductHover = -1))
              }, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, _toDisplayString(item.type), 1),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "char" }, null, -1)),
                  _createElementVNode("div", _hoisted_49, _toDisplayString(item.module), 1)
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("span", _hoisted_52, _toDisplayString(item.zhName), 1),
                    _createElementVNode("span", _hoisted_53, _toDisplayString(item.enName), 1)
                  ]),
                  _createElementVNode("div", _hoisted_54, _toDisplayString(item.intro), 1)
                ]),
                _createElementVNode("div", {
                  class: "bg",
                  style: _normalizeStyle(`height: ${_ctx.currnetProductHover === index && _ctx.currnetProductIndex !== index ? '100%' : '0px'}`)
                }, null, 4)
              ], 42, _hoisted_46), [
                [_vShow, Math.ceil((index + 1) / 4) === _ctx.currentProductPage]
              ])
            ], 8, _hoisted_45))
          }), 128))
        ])
      ]),
      (_ctx.productList.length > 4)
        ? (_openBlock(), _createBlock(_component_MyPage, {
            key: 0,
            total: _ctx.productList.length,
            currentPage: _ctx.currentProductPage,
            onChangePage: _ctx.changeCurrentPage
          }, null, 8, ["total", "currentPage", "onChangePage"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_55, [
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificateList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "certificate-item",
              key: index
            }, [
              _createElementVNode("img", {
                src: item.img,
                alt: ""
              }, null, 8, _hoisted_58)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(_component_MyFooter)
  ]))
}